const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'packages/patapp_web/src/config/ukbb/eCheckin/translations.ts';
import { defineMessages } from '@cistec/common_web/utils/intlUtils';

declare const __RELATIVE_SOURCE_FILE__: string;

export default defineMessages(
    {
        keinHausarzt: 'Kind hat keinen Kinderarzt/Hausarzt oder der Arzt ist nicht in der Auswahlliste vorhanden.',
        doctor: 'Kinderarzt / Hausarzt',
        contact: 'Ansprechpersonen',
        prioritycontact: 'Hauptansprechperson',
        contactdescription: 'Diese Kontaktperson ist unsere prioritäre.',
        secndBeziehung: 'Weitere Kontaktperson',
        keineAngaben: 'Ich möchte keine Angaben zu Angehörigen machen',
        beziehung: 'Beziehung',
        patInfo: 'Hinweise',
        ukkbInfos: 'Unter folgendem Link finden Sie weiterführende Informationen zum Aufenthalt.',
        aufenthalt: 'Informationen zum Aufenthalt',
        persAngaben: 'Persönliche Angaben',
        male: 'Männlich',
        female: 'Weiblich',
        ledig: 'Ledig',
        verheiratet: 'Verheiratet',
        geschieden: 'Geschieden',
        dateOfBirth: 'Geburtstag',
        gender: 'Geschlecht',
        zivilstand: 'Zivilstand',
        language: 'Sprache',
        nationality: 'Nationalität',
        hometown: 'Heimatort',
        profession: 'Beruf',
        religion: 'Religion',
        ahv: 'AHV-Nr.',
        ahvInvalid: 'Bitte tragen Sie eine gültige AHV-Nummer ein. Das Format sollte 756xxxxxxxxxx sein.',
        ahvHelpText: 'Geben Sie Ihre 13-stellige AHV-Nummer in dieses Feld ein.',
        versicherungLabel: 'Versicherung',
        versicherungName: 'Name der Versicherung',
        klasse: 'Versicherungs­klasse',
        behandlungsgrund: 'Behandlungsgrund',
        policyNr: 'Versicherungs­nummer',
        finalizeTitle: 'Online Check-In abschliessen',
        finalizeContent:
            'Bitte bestätigen Sie, dass Ihre Angaben vollständig und korrekt sind, und schliessen Sie das Online-Check-in ab.<br/><b>Wichtig</b>: Nach Abschluss können Ihre Angaben <b>nicht mehr geändert werden</b>.',
        giveawayTitle: 'iPad-Verlosung',
        giveawayConditions:
            'Falls Sie wünschen, können Sie an der iPad-Verlosung teilnehmen. Die Teilnahmebedingungen finden Sie unter {link}.',
        giveawayConditionsLink: 'Teilnahmebedingungen für die iPad Verlosung | UKBB',
        giveawayCheckbox: 'Ja, ich möchte an der iPad-Verlosung teilnehmen.',
    },
    __RELATIVE_SOURCE_FILE__
);
